<template>

  <div id="chat">
    <div v-if="showModalBienvenida && !subscription" class="modal" id="modal-bienvenida">
      <div class="modal-content">
        <span class="close" @click="showModalBienvenida = false">&times;</span>
        <h1>¡Bienvenidx!</h1>
        <p>A nosotros no nos financia ningún gobierno, ni empresario.</p>
        <p>Vamos a empezar con 5 preguntas sin cargo y desde ahí te vamos a pedir una colaboración.</p>
        <p>Con lo que esté al alcance de tu mano nos ayudás mucho a cubrir el costo y te hacés parte de la Comunidad La
          Izquierda Diario, teniendo como beneficio el acceso ilimitado cada mes a ChatPTS.</p>
        <p>¿Arrancamos?</p>
        <div class="botones">
          <button @click="showModalBienvenida = false" class="probar">
            <h3>Probar 5 preguntas gratis</h3>
          </button>
          <p>- ó -</p>
          <button class="suscribirse" @click="goSuscribirse">
            <h3>✨ Suscribirse desde $3.000 ✨</h3>
          </button>
          <p>- ó -</p>
          <button class="suscribirse">
            <RouterLink to="/ya-me-suscribi">
              <h3>YA PAGUÉ MI SUSCRIPCIÓN</h3>
            </RouterLink>
          </button>
        </div>
        <p>- ó -</p>
        <a @click="goToPublicQuestions" class="public-questions">Navegar preguntas públicas</a>
      </div>
    </div>
    <div v-if="showModal" class="modal" id="modal-suscripciones">
      <div class="modal-content">
        <span class="close" @click="showModal = false">&times;</span>
        <h1>¡Ups! Límite de mensajes alcanzado</h1>
        <p>¡Nos encanta que estés usando ChatPTS!</p>
        <p>Si llegaste hasta acá, parece que estamos en la misma y te vamos a pedir una ayuda.</p>
        <p>A nosotros no nos financia ningún gobierno, ni empresario. Con el aporte económico que esté a tu alcance nos
          ayudás mucho a bancar esto y te hacés parte de la Comunidad La Izquierda Diario, teniendo como beneficio el
          acceso ilimitado cada mes a ChatPTS. ¿Te sumás?</p>
        <div class="modal-buttons">
          <button class="btn-primary" @click="goSuscribirse">
            ✨ Suscribirse desde $3.000 ✨
          </button>
          <button class="btn-secondary">
            <RouterLink to="/ya-me-suscribi">
              YA PAGUÉ MI SUSCRIPCIÓN
            </RouterLink>
          </button>
          <button class="btn-tertiary" @click="goToPublicQuestions">
            Navegar preguntas públicas
          </button>
        </div>
      </div>
    </div>
    <div v-if="showPopupTips" class="modal" id="modal-tips">
      <div class="modal-content">
        <span class="close" @click="togglePopupTips">&times;</span>
        <p class="disclaimer mobile-only">¿Qué te pareció la respuesta? ChatPTS es un proyecto
          experimental. Puede cometer errores y no reflejar las posiciones del PTS o La Izquierda Diario. Te invitamos a
          explorar las fuentes. Si encontrás algún error, <a target='_blank'
            href='https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit'>tus comentarios y
            sugerencias para mejorar son bienvenidos!</a></p>
        <h1>Algunos tips para tener una mejor experiencia:</h1>
        <p>Mientras trabajamos para mejorar este experimento, te damos algunos consejos que pueden resultar útiles para
          que encuentres lo que buscás.</p>
        <ul>
          <li>Mientras más específcx seas en tu consulta, mejor. Por ejemplo, "cómo discutir con alguien que sigue
            convencido de que Milei va a bajar impuestos" es mejor que "cómo discutir con Milei".</li>
          <li>Si te interesan resultados de una fecha o período específico, podés pedirlos y el bot te va a entender.
            Por ejemplo, "¿Qué dijo Myriam Bregman la primera vez que se presentó el RIGI en mayo de 2024?".</li>
          <li>Mientras más contexto, mejor. Por ejemplo "cuáles son las diferencias entre los partidos de Izquierda en
            Argentina" es mejor que "diferencias entre partidos de Izquierda".</li>
          <li>Recordá que todas las preguntas que hagas podrán verlas otrxs (anonimizadas sin ningún dato tuyo). Con
            esto queremos lograr mayor transparencia y que todxs disfrutemos el contenido del chat.</li>
        </ul>
      </div>
    </div>
    <div :class="['chat-window', { blur: showModal }]">
      <div class="messages-window" ref="messagesWindow" :class="{ empty: chatHistory.length === 0 && !isLoading }">
        <div class="messages-container">

          <!--If chatHistory is empty, show prompt suggestions -->
          <div v-if="chatHistory.length === 0 && !this.isLoading && this.is_new_conversation"
            class="prompt-suggestions">
            <PromptSuggestionComponent v-for="prompt in promptSuggestions" :key="prompt.id"
              @click="createConversationFromPromptSuggestion(this.userId, this.conversation_id, prompt.prompt, prompt.prompt_suggestion_id)"
              :prompt="prompt.prompt" :prompt_suggestion_id="prompt.prompt_suggestion_id" :use_count="prompt.use_count"
              :icon="prompt.icon" />
          </div>

          <div v-if="isLoadingHistory && !this.is_new_conversation" class="loader">
            <h1>Cargando...</h1>
          </div>

          <button v-if="hasMore && !isLoadingHistory && !this.is_new_conversation" class="load-more"
            @click="getChatHistory(conversation_id, true)">Cargar
            más</button>

          <div v-for="message in chatHistory" :key="message._id" :id="'message-' + message._id"
            class="message-duplex-container">
            <HumanMessageComponent :text="message.q" :timestamp="message.timestamp"
              :conversation_id="message.conversation_id" :profile-picture="profilePic" :user-name="userName" />
            <KotBotMessageComponent @show-toast="showToast" :text="message.a" :qanda_id="message._id"
              :has_feedback="message.feedback !== null" :timestamp="message.timestamp"
              :conversation_id="message.conversation_id" :sources="message?.sources"
              :streamAhora="streamAhora && message._id == lastMessageId" />
          </div>
          <HumanMessageComponent v-if="this.isLoading" :text="this.newMessage" :timestamp="''" :show-timestamp="false"
            :conversation_id="this.conversation_id" :profile-picture="profilePic" :user-name="userName" />
          <KotBotMessageComponent @show-toast="showToast" v-if="this.isLoading" :qanda_id="null"
            :is-loading="this.isLoading" :text="!mensajeEsperaMostrado ? 'Cargando...' : mensajeEsperaMostrado"
            :conversation_id="this.conversation_id" />
        </div>
      </div>
    </div>

    <div class="chat-controls">
      <div class="chat-controls-inner">
        <textarea autofocus :disabled="this.isLoading" type="text" v-model="newMessage"
          placeholder="Escribe tu mensaje aquí..."
          @keyup.enter="sendMessage(this.userId, this.conversation_id)"></textarea>
        <button :disabled="this.isLoading" @click="sendMessage(this.userId, this.conversation_id)"
          @keyup.enter="sendMessage(this.userId, this.conversation_id)" class="send-button desktop"><ion-icon
            :src="require('@/assets/icons/send-outline.svg')"></ion-icon></button>
        <button :disabled="this.isLoading" @click="sendMessage(this.userId, this.conversation_id)"
          @keyup.enter="sendMessage(this.userId, this.conversation_id)" class="send-button mobile">
          <ion-icon name="send-outline"></ion-icon>
        </button>
      </div>
      <div class="disclaimer">
        <button class="moreInfo" @click="togglePopupTips"><ion-icon name="help"></ion-icon></button>

        <p>ChatPTS es un proyecto experimental. Puede cometer errores y no reflejar
          las posiciones del PTS o La Izquierda Diario. <span class="big-desktop-only">Te invitamos a explorar las
            fuentes.</span> Si encontrás
          errores, <a target='_blank'
            href='https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit'>tus
            comentarios son bienvenidos!</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import KotBotMessageComponent from './KotBotMessageComponent.vue';
import HumanMessageComponent from './HumanMessageComponent.vue';
import PromptSuggestionComponent from './PromptSuggestionComponent.vue';

import axios from 'axios';
import { COUNTRY } from '../utils/countryConfig';
axios.defaults.withCredentials = true;

export default {
  name: "ChatComponent",
  props: {
    email: {
      type: String,
      required: true
    },
    conversation_id: {
      type: String,
      required: false,
      default: null,
    },
    conversation_title: {
      type: String,
      required: false,
      default: null,
    },
    promptSuggestions: {
      type: Array,
      required: false,
      default: () => []
    },
    is_new_conversation: {
      type: Boolean,
      required: false,
      default: true,
    },
    profilePic: {
      type: String,
      required: false,
      default: null,
    },
    userName: {
      type: String,
      required: false,
      default: null,
    },
    subscription: {
      type: Object,
      required: false,
      default: null
    },
  },
  components: {
    KotBotMessageComponent,
    HumanMessageComponent,
    PromptSuggestionComponent,
  },
  data() {
    return {
      chatHistory: [],
      newMessage: '',
      userId: this.email,  // Puedes ajustar esto según tu lógica de autenticación
      isLoading: false,
      isLoadingHistory: false,
      showModal: false,
      mensajesEspera: [
        "Esto demora unos pocos segundos… Mientras tanto quería decirte que nos encanta que estés usando ChatPTS, es un proyecto que nos tiene muy entusiasmados. ¿Nos das una mano para seguir desarrollando esta experiencia innovadora? Con el aporte económico que esté a tu alcance nos ayudás mucho y te hacés parte de la Comunidad La Izquierda Diario, con acceso ilimitado cada mes a ChatPTS",
        "Estoy buscando tu respuesta... Mientras tanto: En La Izquierda Diario no solo informamos, ¡nos organizamos! Si te interesa enfrentar el ajuste y construir una alternativa socialista, escribinos acá y sumate a militar con nosotros.",
        "Esto va a demorar un poquito, ya volvemos. ¿Te gustan los contenidos de La Izquierda Diario? ¡Compartilos con tus compañerxs de laburo, estudio, amigos o familia! Así seguimos creciendo y difundiendo una alternativa socialista."
      ],
      mensajeEsperaMostrado: '',
      intervalId: null, // ID del intervalo para limpiar más tarde si es necesario
      lastMessageId: null,
      streamAhora: false,
      disclaimer: "",
      showPopupTips: false,
      showModalBienvenida: false,
      offset: 0,
      limit: 10,
      hasMore: true,
      newlyCreatedConversationId: null,
    };
  },
  watch: {
    userId() {
      this.getChatHistory();
    },
    conversation_id(newConversationId) {
      if (this.newlyCreatedConversationId && newConversationId === this.newlyCreatedConversationId) {
        this.newlyCreatedConversationId = null;
        return;
      }
      this.chatHistory = [];
      this.newMessage = '';
      this.offset = 0;
      this.hasMore = true;
      this.isLoadingHistory = false;
      if (newConversationId) {
        this.getChatHistory(newConversationId);
      }
    },
  },
  methods: {
    togglePopupTips() {
      this.showPopupTips = !this.showPopupTips;
    },
    mostrarMensajeAleatorio() {
      // Detenemos cualquier intervalo anterior para evitar conflictos
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      // Elegimos un mensaje aleatorio de la lista
      const mensajeAleatorio = this.mensajesEspera[
        Math.floor(Math.random() * this.mensajesEspera.length)
      ];

      // Dividimos el mensaje en frases 
      const palabras = mensajeAleatorio.split(' ');
      const frases = [];
      for (let i = 0; i < palabras.length; i += 4) {
        frases.push(palabras.slice(i, i + 4).join(' '));
      }

      // Reseteamos el mensaje mostrado
      this.mensajeEsperaMostrado = "";

      // Inicializamos el contador para mostrar cada frase
      let index = 0;

      // Configuramos un intervalo que mostrará cada frase de a una
      this.intervalId = setInterval(() => {
        if (index < frases.length) {
          // Añadimos la frase actual al mensaje mostrado
          this.mensajeEsperaMostrado += frases[index] + " ";
          index++;
        } else {
          // Limpiamos el intervalo cuando se han mostrado todas las frases
          clearInterval(this.intervalId);
        }
      }, 400); // Cada frase se mostrará cada 1000 ms (1 segundo)
    },
    async getChatHistory(conversationId = null, fromLoadMore = false) {
      if (this.isLoadingHistory || !this.hasMore) return;

      this.isLoadingHistory = true;

      let params = {
        offset: this.offset,
        limit: this.limit,
        country: COUNTRY
      }

      if (conversationId) {
        params.conversation_id = conversationId;
      }
      try {
        const response = await axios.get(process.env.VUE_APP_BASE_URL + '/api/v2/chat/get-user-conversation/', {
          params: params,
        });

        if (response.data[0]?.conversation_id == this.conversation_id) {
          // Get new messages to the beginning of the chat
          this.chatHistory = response.data.concat(this.chatHistory);
          this.offset += this.limit; // Increment offset for the next batch
        } else {
          this.chatHistory = [];
          this.newMessage = '';
          this.offset = 0;
          this.hasMore = true;
          this.isLoadingHistory = false;
          console.log('No se encontró la conversación');
          return this.getChatHistory(this.conversation_id);
        }

        if (response.data.length < this.limit) {
          this.hasMore = false;
        }

      } catch (error) {
        // If status is 404, then the user is new
        if (error.response && error.response.status === 404) {
          this.chatHistory = [];
        } else if (error.response && error.response.status === 401) {
          // emit logout event
          this.$emit('logout');
          this.$router.push({ name: 'main-view' });
          this.showToast("Sesión expirada o inválida - por favor, volvé a ingresar", "warning");
        } else if (error.response && error.response.status === 426) {
          this.showModal = true;
          this.showToast(error.response.data.detail, "error");
        } else if (error.response && (error.response.status === 400 || error.response.status === 429)) {
          const message = error.response.data.detail;
          this.showToast("ERROR: " + message, "error");
        } else if (error.response && (error.response.status === 409)) {
          const message = error.response.data.detail;
          this.showToast("ERROR: " + message, "error");
        } else {
          console.error('Error al obtener el historial de chat:', error);
          this.showToast("¡Estamos con mucha demanda! Intenta nuevamente.", "error");
        }
      }

      this.isLoadingHistory = false;

      if (this.chatHistory.length > 0 && !fromLoadMore) {
        this.scrollToElement(`#message-${this.chatHistory[this.chatHistory.length - 1]._id}`);
      }


    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    async sendMessage(email, conversationId = null, promptSuggestionId = null) {
      if (this.isLoading) return;
      if (this.newMessage.trim() === '') return;


      try {
        this.isLoading = true;
        this.mostrarMensajeAleatorio();

        this.scrollBottom();

        const activeConversationId = conversationId || this.conversation_id || this.generateUUID();

        const trimedCleanMessage = this.newMessage.trim().replace(/<[^>]*>?/gm, '');
        let body = {
          question: trimedCleanMessage,
          country: COUNTRY,
          legacy: false, // Set legacy to false for 2.0 version
          conversation_id: activeConversationId,
        };

        if (promptSuggestionId) {
          body.prompt_suggestion_id = promptSuggestionId;
        }


        const response = await axios.post(process.env.VUE_APP_BASE_URL + "/api/v2/chat/answer/", body, {
          timeout: 120000 // 120 seconds in milliseconds
        });

        this.newMessage = '';
        // If this is the first message, emit new-conversation-name with the response.data.q value
        if (this.chatHistory.length === 0) {
          if (this.conversation_id !== response.data.conversation_id) {
            this.newlyCreatedConversationId = response.data.conversation_id;
          }
          this.$emit('new-conversation-name', response.data.q, response.data.conversation_id);
        }

        this.lastMessageId = response.data._id;
        this.streamAhora = true;
        this.chatHistory.push(response.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // emit logout event
          this.$emit('logout');
          this.$router.push({ name: 'main-view' });
          this.showToast("Sesión expirada o inválida - por favor, volvé a ingresar", "warning");
        }
        this.isLoading = false;
        // If response has "detail" key and "La pregunta debe tener al menos 10 caracteres" value is in that key, then show alert
        if (error.response && error.response.data?.detail === 'La pregunta debe tener al menos 10 caracteres') {
          this.showToast("La pregunta debe tener al menos 10 caracteres", "warning");
        } else if (error.response && error.response.status === 426) {
          this.showModal = true;
          this.showToast(error.response.data.detail, "error");
        } else if (error.response && (error.response.status === 400 || error.response.status === 429)) {
          const message = error.response.data.detail;
          this.showToast("ERROR: " + message, "error");
        }
        else if (error.response && (error.response.status === 409)) {
          const message = error.response.data.detail;
          this.showToast("ERROR: " + message, "error");
        } else {
          console.error('Error al enviar mensaje:', error);
          this.showToast("¡Estamos con mucha demanda!. Intenta nuevamente.", "error");
        }


      }

      if (this.chatHistory.length > 0) {
        this.scrollToElement(`#message-${this.chatHistory[this.chatHistory.length - 1]._id}`);
      }

      this.isLoading = false;
    },
    async createConversationFromPromptSuggestion(email, conversationId, prompt, promptSuggestionId) {
      this.newMessage = prompt;
      this.sendMessage(email, conversationId, promptSuggestionId);
    },
    async scrollBottom() {
      const messagesWindow = this.$refs.messagesWindow;
      await new Promise(resolve => setTimeout(resolve, 500));
      messagesWindow.scrollTo({
        top: messagesWindow.scrollHeight,
        behavior: 'smooth'
      });
    },
    async scrollToElement(selector) {
      const messagesWindow = this.$refs.messagesWindow; // No need to use `.value` in Options API

      // Ensure the messagesWindow is properly referenced
      if (messagesWindow) {
        // Wait for a short time before scrolling
        await new Promise(resolve => setTimeout(resolve, 500));

        const targetElement = messagesWindow.querySelector(selector); // Target child element

        if (targetElement) {
          // Scroll to the child element inside the parent container
          messagesWindow.scrollTo({
            top: targetElement.offsetTop,  // Scroll to the top position of the target element
            behavior: 'smooth'  // Smooth scrolling
          });
        } else {
          console.error(`Element with selector "${selector}" not found.`);
        }
      } else {
        console.error('messagesWindow is not defined.');
      }
    },
    showToast(message, type) {
      this.$emit('show-toast', message, type);
    },
    goSuscribirse() {
      this.$router.push({ name: "suscribirse" });
    },
    goToPublicQuestions() {
      this.$router.push({ name: "public-questions" });
    }

  },
  async mounted() {
    if (!this.is_new_conversation) {
      await this.getChatHistory();
    }
    else {
      this.isLoadingHistory = false;
    }

  }
};
</script>

<style scoped>
#chat {
  min-width: 600px;
  height: 100vh;
  /* Fallback para navegadores antiguos */
  height: 100dvh;
  /* Dynamic viewport height */
  background-color: rgba(250, 250, 250, 0.9);
  border-radius: 0 0 8px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333333;
  display: grid;
  grid-template-rows: 1fr auto;
  flex-grow: 1;
  overflow: hidden;
}

h1 {
  text-align: center;
  color: #a1344e;
  margin-bottom: 24px;
  /* Rojo principal */
}

.chat-window {
  grid-row: 1;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  /* Rojo principal */
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.chat-window.blur {
  filter: blur(10px);
}



.messages-window {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 12px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  overscroll-behavior: contain;
}

.messages-window.empty .messages-container,
.messages-window.empty {
  justify-content: center;
  align-items: center;
}


.messages-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 1300px;
  padding-top: 124px;
  width: 100%;
}

.message-duplex-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  width: 100%;
  justify-content: flex-start;
}


textarea {
  width: 100%;
  padding: 6px 24px;
  border: none;
  border-radius: 15px;
  margin-right: 10px;
  font-size: 14pt;
  height: 45px;
  /* background-color: rgb(50, 50, 50); */
  height: 75px;
  color: #333;
}

.send-button {
  background-color: #a1344e;
  /* Rojo principal */
  color: white;
  border: none;
  padding: 16px;
  border-radius: 40px;
  cursor: pointer;
  font-size: 20pt;
  flex-grow: 1;
  text-transform: uppercase;
  font-weight: bold;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 70px;
}

.send-button.mobile {
  display: none;
}

.send-button:hover {
  background-color: #b71c1c;
  /* Rojo oscuro */
}

.moreInfo {
  align-self: center;
  padding: 9px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 48px;
  border: none;
  margin-right: 12px;
  cursor: pointer;
  box-sizing: content-box;
  border-color: rgba(50, 50, 50);
  border: 1px solid;
  color: #333;
  font-weight: bold;
  aspect-ratio: 1;
}

.moreInfo ion-icon {
  font-size: 12pt;
}


.moreInfo:hover {
  border: 1px solid #a1344e;
  color: #a1344e;
}

h4.conversation-header {
  margin-bottom: 12px;
  background-color: #eee;
  padding: 12px;
}

.disclaimer {
  font-size: 11pt;
  line-height: 1.05;
  width: 100%;
  margin-top: 12px;
  border-radius: 40px;
  color: #333;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

.disclaimer a {
  color: #000;
}

.disclaimer a:visited {
  color: #333;
}


.chat-controls {
  grid-row: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(250, 250, 250, 0.95);
  padding: 12px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.chat-controls-inner {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
}

.chat-controls textarea {
  border: 1px solid #ccc;
}

.chat-controls button {
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.3);
}


.padding {
  width: 100%;
}

.loader {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.25);
}

.loader h1 {
  padding: 24px;
  border-radius: 8px;
  color: #333;
  margin-top: -120px;
}

.prompt-suggestions {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-self: center;
  justify-self: center;
  max-width: 1000px;
  padding: 24px 0;
}

.modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.75);
}

.modal-content {
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  max-width: 900px;
  padding: 24px 48px;
  padding-bottom: 48px;
  background-color: rgba(230, 230, 230, 1);
  border-radius: 12px;
  color: #333333;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.3);
  max-height: 90%;
  overflow-y: auto;
}

.modal-content p,
.modal-content li {
  margin-bottom: 12px;
  font-size: 16pt;
  text-align: center;
}

.modal-content li {
  text-align: left;
}

.close {
  font-size: 30pt;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-end;
  color: #333333;
}

.close:hover {
  color: #a1344e;
}

.suscribirse {
  background-color: #a1344e;
  border: none;
  color: #f0f0f0;
  padding: 12px 24px;
  margin-top: 24px;
  margin-bottom: 24px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15pt;
}

.suscribirse:hover {
  background-color: #b71c1c;
}



.mobile-only {
  display: none;
}

.botones {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.botones>p {
  margin: 0 12px;
  padding: 6px;
  flex-shrink: 0;
}

.botones .probar {
  background-color: #f0f0f0;
  color: #333333;
  border: none;
  padding: 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14pt;
}

.load-more {
  border: none;
  background-color: #a1344e;
  color: #ffffff;
  border-radius: 4px;
  padding: 16px;
  cursor: pointer;
  font-size: 12pt;
  margin-bottom: 12px;
  align-self: center;
  font-weight: bold;
  text-transform: uppercase;
  transition: all .2s ease-in-out;
  margin-top: 20px;
}

/* New modal button styles */
.modal-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
  width: 100%;
  max-width: 400px;
}

.btn-primary {
  border: none;
  background-color: #a1344e;
  color: #ffffff;
  border-radius: 4px;
  padding: 12px 24px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  text-transform: none;
  transition: all .2s ease-in-out;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-primary:hover {
  background-color: #b71c1c;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-secondary {
  border: 1px solid rgba(161, 52, 78, 0.3);
  background-color: transparent;
  color: #333333;
  border-radius: 4px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  text-transform: none;
  transition: all .2s ease-in-out;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-secondary:hover {
  background-color: rgba(161, 52, 78, 0.1);
  border-color: #a1344e;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-secondary a {
  color: inherit;
  text-decoration: none;
}

.btn-tertiary {
  border: 1px solid rgba(102, 102, 102, 0.3);
  background-color: transparent;
  color: #666666;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
  text-transform: none;
  transition: all .2s ease-in-out;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-tertiary:hover {
  background-color: rgba(102, 102, 102, 0.1);
  border-color: #666666;
  color: #333333;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 1100px) {
  .big-desktop-only {
    display: none;
  }

  .messages-container {
    padding-top: 24px;
  }
}

@media screen and (max-width: 600px) {

  #chat {
    min-width: 100%;
    max-width: 100%;
    margin-left: 0;
  }

  .messages-window {
    padding-right: 0;
  }

  .chat-controls {
    width: 100%;
    margin: 0;
    padding: 10px;
    padding-bottom: calc(10px + env(safe-area-inset-bottom, 10px));
    flex-direction: column;
    align-items: center;
  }

  .chat-controls textarea {
    margin-bottom: 12px;
    margin: 0;
    margin-right: 12px;
    flex-grow: 1;
  }

  .chat-controls button {
    flex-shrink: 0;
    flex-grow: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .prompt-suggestions {
    flex-direction: column;
    width: calc(100% - 48px);
    margin: 0 24px;
  }

  .prompt-suggestion-button {
    width: 100%;
    margin-left: 0;
    margin-bottom: 12px;
    margin-top: 0;
    background-color: transparent;
    color: #333;
    justify-content: flex-start;
  }

  .send-button.desktop {
    display: none;
  }

  .send-button.mobile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    aspect-ratio: 1/1;
    padding: 12px 18px;
    max-width: 60px;
    max-width: 60px;
    align-self: center;
  }



  .send-button.mobile ion-icon {
    font-size: 25pt;
    color: #fff;
    flex-shrink: 0;
  }

  .disclaimer {
    display: none;
  }

  .disclaimer.mobile-only {
    display: block;
    width: 100%;
    background-color: transparent;
    margin-bottom: 24px;
  }

  .modal-content {
    width: 90%;
    height: 95%;
    overflow-y: auto;
    padding: 12px 24px;
  }

  .modal-content p {
    text-align: left;
    font-size: 14pt;
  }

  .modal-content h1 {
    color: #a1344e;
    line-height: 1.1;
  }

  .botones {
    flex-direction: column;
  }

}
</style>
